module.exports = __webpack_public_path__ + "static/media/luma-star-active.81076faa.svg";